// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";

function $$catch(promise, callback) {
  return promise.catch(function (err) {
              return callback(Caml_js_exceptions.internalToOCamlException(err));
            });
}

export {
  $$catch ,
}
/* No side effect */
